import { getStore } from "store";

export default function (nextState, replace, callback) {
    const { scope } = getStore().getState();

    if (scope && scope.brand && scope.brand.hasModuleEnabled("drive")) {
        const { pathname } = nextState.location;

        const drivePath = "/drive";
        if (pathname !== drivePath) {
            replace({
                pathname: drivePath,
            });
        }
    }

    callback();
}
